import React, { useContext, useState } from 'react';

import { RestApiContext } from '../../../contexts/RestApiContext';
import { useAggregatedState, useBusyState } from '../../../../helpers';

export const PageContext = React.createContext(null);

const { Provider } = PageContext;
export const PageProvider = ({ ...props }) => {
    const [pageIsReady, setPageIsReady] = useState(false);
    const [busy, isBusy, setIsBusy] = useBusyState({});
    const [state, setState] = useAggregatedState({
        table: null
    });

    const apiClient = useContext(RestApiContext);

    const getTableAsync = async (tableId, withUsers) => {
        try {
            const table = await apiClient.getManagedTableAsync(tableId, withUsers);
            setState({ table });
            return true;
        } catch (e) {
            console.debug(e);
            return false;
        }
    }

    const toggleTableAvailabilityAsync = async ({ tableId, isDisabled }) => {
        try {
            const table = await apiClient.toggleTableAvailabilityAsync({ tableId, isDisabled });
            setState({ table });
        } catch (e) {
            console.debug(e);
        }
    }

    const toggleTableAllowImportAsync = async ({ tableId, allowImport }) => {
        try {
            const table = await apiClient.toggleTableAllowImportAsync({ tableId, allowImport });
            setState({ table });
        } catch (e) {
            console.debug(e);
        }
    }

    const toggleTableClearOnImportAsync = async ({ tableId, clearOnImport }) => {
        try {
            const table = await apiClient.toggleTableClearOnImportAsync({ tableId, clearOnImport });
            setState({ table });
        } catch (e) {
            console.debug(e);
        }
    }

    const updateTableAsync = async ({ tableId, isDisabled, allowImport, clearOnImport, description }) => {
        try {
            const table = await apiClient.updateTableAsync({ tableId, isDisabled, allowImport, clearOnImport, description });
            setState({ table });
        } catch (e) {
            console.debug(e);
        }
    }

    return (
        <Provider value={{
            state,
            pageIsReady,
            setPageIsReady,
            isBusy,
            setIsBusy,
            getTableAsync,
            toggleTableAvailabilityAsync,
            toggleTableAllowImportAsync,
            toggleTableClearOnImportAsync,
            updateTableAsync
        }}>
            {props.children}
        </Provider>
    );
}